import React from "react";

import { useState, useRef } from "react";
import { Box, HStack, Image, Text } from "@chakra-ui/react";
import { BiImageAdd } from "react-icons/bi";

export function AdditionalFilesDropbox({ acceptImageType }) {
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file.size <= 100000000) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert("File size must be less than 100MB");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file.size <= 100000000) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert("File size must be less than 100MB");
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Box
      cursor="pointer"
      height="full"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      <input
        type="file"
        accept={acceptImageType}
        onChange={handleFileInputChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
      {image ? (
        <Image
          src={image}
          alt="Uploaded Image"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      ) : (
        <HStack
          gap={1}
          height="full"
          flexDir={{ base: "column", sm: "row" }}
          alignItems={{ base: "start",sm:"center" }}
        >
          <HStack
            gap={2}
            bg="#F4F4F4"
            height="full"
            px={{ base: 2, md: 10 }}
            border="1px dashed #c5c5c5"
            borderRadius={10}
            py={2}
          >
            <BiImageAdd size="24px" />
            <Text fontWeight="semibold">
              Drag & drop a Photo or{" "}
              <Box as="span" color="brand.500" textDecor={"underline"} >
                Browse
              </Box>
            </Text>
          </HStack>
          <Text textAlign={{ base: "start",sm:"center" }}>
            You may attach up to 5 files under <b>100 MB</b> each
          </Text>
        </HStack>
      )}
    </Box>
  );
}
